module.exports = __webpack_public_path__ + "img/smg46_samurai01_shop.4a0cecb2.png";